import React from 'react'
import { Truncate, Box, Text } from 'pcln-design-system'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const ShowHideAirlineTitle = styled(Box)`
  display: none;

  ${(props) => props.theme.flyQueries.tablet} {
    display: block;
  }
`

const AirlineTitle = ({ airlines }) => {
  const airlineNames = airlines.map((airline) => airline.name)
  let text = airlineNames.length > 1 ? 'Multiple' : airlineNames[0]
  // shorten the names that end in Air|Airline(s)| Air Line(s)|Airway(s)|Air Way(s)
  text = text ? text.replace(/( air ?(lines?|ways?)?)$/i, '') : text

  return airlineNames.length ? (
    <ShowHideAirlineTitle>
      <Text fontSize={'10px'} color={'text.light'}>
        <Truncate>{text}</Truncate>
      </Text>
    </ShowHideAirlineTitle>
  ) : null
}

AirlineTitle.propTypes = {
  airlines: PropTypes.any.isRequired,
}

export default AirlineTitle
